import {
  signUp,
  logIn,
  logOut,
  getRecoveryLink,
  resetPassword,
  completeRegistration,
  changePassword,
  getMyProfile,
  deleteAccount,
  editAccount,
  inviteUser,
  resendInvite,
  search,
} from "./auth.action";

export { authReducer } from "./auth.reducer";
export { watchAuth } from "./auth.saga";

export const authActions = {
  /** Auth Actions */
  signUp,
  logIn,
  logOut,
  getMyProfile,
  getRecoveryLink,
  resetPassword,
  completeRegistration,
  changePassword,
  editAccount,
  deleteAccount,
  inviteUser,
  resendInvite,
  search,
};
